import { Highlight } from "@mantine/core";
import "@mantine/hooks";
import * as linkify from "linkifyjs";
import { memo, useEffect, useMemo } from "react";
import { selectSearch } from "src/reducks/SearchStore";
import { useAppSelector } from "src/store/hooks";

export const HighlightTextWrapper = ({ text }: { text: string }) => {
  const searchState = useAppSelector(selectSearch);

  const validText = text ?? "";
  // Find links
  const linksDetected = linkify.find(validText);

  const highlight = linksDetected
    .filter((link) => link.isLink)
    .map((link) => link.value);
  if (searchState.search?.length) {
    highlight.push(searchState.search);
  }

  // when is link then replace <mark> tag to <a> tag
  useEffect(() => {
    if (!linksDetected.length) {
      return;
    }
    const elements = document.querySelectorAll("mark");
    elements.forEach((element) => {
      const link = linksDetected.find(
        (link) => link.value === element.textContent,
      );
      if (link) {
        element.outerHTML = `
          <a href="${link.href}" style="color:#00A5B9;position: relative;z-index=5" target="blank">${link.value}</a>
        `;
      }
    });
  }, [linksDetected]);

  const contentText = useMemo(() => {
    const lines = validText.split(/\r?\n|\r|\n/g);
    return lines.map((text, index) => {
      return (
        <Highlight
          key={index}
          highlightColor="#00A5B9"
          highlightStyles={() => {
            return {
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            };
          }}
          highlight={highlight}
        >
          {text}
        </Highlight>
      );
    });
  }, [validText, highlight]);

  return <div>{contentText}</div>;
};

export const HighlightTextWrapperMemo = memo(HighlightTextWrapper);
